module.exports = __webpack_public_path__ + "img/联动图.fa6d15d3.png";